import { filterOptions } from "@src/helpers/constants";
import { Form, Select } from "antd";
import { startCase } from "lodash";
import React from "react";

interface DeviceTypeComponentProps {}

const DeviceTypeComponent: React.FC<DeviceTypeComponentProps> = ({}) => {
  return (
    <Form.Item
      name="deviceType"
      label="Type"
      rules={[
        {
          required: true,
          message: "Please select the type",
        },
      ]}
    >
      <Select placeholder="" options={filterOptions.deviceTypes} />
    </Form.Item>
  );
};

export default DeviceTypeComponent;
